import React, { lazy, Suspense } from 'react'

import SkeletonCompanyExperience from '@/core/skeletons/SkeletonCompanyExperience'
const Main = lazy(() => import('./Main'))

const MainLazy = props => {
  return (
    <Suspense fallback={<SkeletonCompanyExperience />}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Main {...props} />
    </Suspense>
  )
}

export default MainLazy
